import appHostList from '../../../constants/appHostList';
import { environment_name } from '../../../constants/environment';

const getInstallIframeLink = () => `https://${appHostList[environment_name]}`;

export default getInstallIframeLink;
